import { Row, Title, useTranslation } from '@packages/utils';
import { TGeneralElcDocsSectionProps } from './GeneralElcDocsSection.types';
import ResourceItem from '../components/ResourceItem';

const GeneralElcDocsSection = ({
  data,
  elcId,
  isResourceEditable,
}: TGeneralElcDocsSectionProps) => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.admin-portal.elcs.detail.resources-tab.sections',
  });
  return (
    <>
      <Title level={4} className="mt-6 mb-3" data-cy="general-elc-docs-title">
        {t('GENERAL_ELC_DOCS')}
      </Title>
      <Row gutter={[16, 16]} data-cy="general-elc-docs-list">
        {data.map(item => (
          <ResourceItem
            key={item.resourceId}
            data={item}
            elcId={elcId}
            isResourceEditable={isResourceEditable}
          />
        ))}
      </Row>
    </>
  );
};

export default GeneralElcDocsSection;
